// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string, boolean } from "@altostra/type-validations/lib/primitives";

export const isEngagementEmailTemplatesResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      description: string,
      name: string,
      tag_names: arrayOf(string),
      territory_ids: arrayOf(string),
      last_edited_at: number,
      created_at: number,
      marked_as_deleted: boolean,
      is_dnd_template: boolean,
      created_by: string,
      template: string,
    })
  ),
});

export const isEmailTemplateSourcesResult = objectOf({
  sources: arrayOf(
    objectOf({
      uid: string,
      name: string,
    })
  ),
});
